import React, { useEffect, useState } from 'react'

import { Card, SuccessModal } from 'components'
import { useLoading, useModal, usePersistForm, useToggle } from 'hooks'
import moment from 'moment'
import { ViewContractModal } from 'pages/NGT/CRE/components/ViewContractModal/ViewContractModal'
import {
  CenterServices,
  CompanyServices,
  DocumentoCaixaServices,
  IDocumentoCaixaResponseDto,
  IDocumentoCaixaSearchDto
} from 'services/NGT/Files'
import { COLORS, SPACING } from 'utils'
import { unmask } from 'utils/masks'

import { FilterTableRegister, TableRegisterDocumentation } from './components'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
export interface ISearchParamsDocumento {
  contrato: string
  idEmpresa: number
  idCentro: number
  cnpj: string
  fornecedor: string
  competencia: Date | null
  caixaExterno: string
  caixaDepartamental: string
}

const SCHEMA = yup.object({
  caixaDepartamental: yup.string().nullable().notRequired(),
  caixaExterno: yup.string().nullable().notRequired(),
  idCentro: yup.number().nullable().notRequired(),
  idEmpresa: yup.number().nullable().notRequired(),
  cnpj: yup.string().nullable().notRequired(),
  competencia: yup.date().nullable(),
  contrato: yup.string().nullable().notRequired(),
  fornecedor: yup.string().nullable().notRequired(),
})

interface SearchDocumentationProps {
  handleEdit: (_document: IDocumentoCaixaResponseDto) => void
}

const SearchDocumentation: React.FC<SearchDocumentationProps> = ({
  handleEdit
}) => {
  const { setLoading, setMsgErro } = useLoading()

  const { control, watch, setValue, formState: { errors }, reset, handleSubmit } = useForm<ISearchParamsDocumento>({
    resolver: yupResolver(SCHEMA),
    defaultValues: {
      caixaDepartamental: '',
      caixaExterno: '',
      idCentro: null,
      cnpj: '',
      competencia: null,
      contrato: '',
      idEmpresa: null,
      fornecedor: ''
    }
  })

  usePersistForm('ngt_register_documentation_search', {
    setValue,
    watch
  })

  const { showModal } = useModal()
  const [documentosCaixa, setDocumentosCaixa] = useState<
    IDocumentoCaixaResponseDto[]
  >([])

  const [empresas, setEmpresas] = useState<
    { nmEmpresa: string; idEmpresa: number }[]
  >([])
  const [centros, setCentros] = useState<
    { nmCentro: string; idCentro: number }[]
  >([])
  const [idDocumentoDeletado, setIdDocumentoDeletado] = useState<number>(-1)
  const [toggleDeleteModal, setToggleOpenDeleteModal] = useToggle()
  const [openViewContractModal, toggleViewContractModal] = useToggle()
  const [selectedContractId, setSelectedContractId] = useState(0)

  const [page, setPage] = React.useState<number>(1)
  const [rowSize, setRowSize] = React.useState<number>(0)
  const [rowsPerPage, setRowsPerPage] = React.useState<number>(15)

  const handleDeleteDocumentoCaixa = () => {
    setLoading('loading')
    DocumentoCaixaServices()
      .del(idDocumentoDeletado)
      .then(() => {
        handleSetDocumentoCaixas()
        setToggleOpenDeleteModal()
      })
      .catch((err) => {
        // setMsgErro(err)
        showModal({
          hideButtonCancel: true,
          message: 'Erro ao obter os dados da pesquisa',
          txtButtonConfirm: 'OK',
          type: 'alert'
        })
        setLoading('error')
      })
      .finally(() => {
        setIdDocumentoDeletado(-1)
        setLoading('idle')
      })
  }

  useEffect(() => {
    if (selectedContractId) {
      toggleViewContractModal()
    }
  }, [selectedContractId])

  const cleanFields = () => {
    setPage(1)
    reset()
    handleSetDocumentoCaixas()
  }

  // const handleChangeFields = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   setSearchParams({
  //     ...searchParams,
  //     [event.target.name]:
  //       event.target.name !== 'contrato' && event.target.name !== 'fornecedor'
  //         ? event.target.value.replace(/[^a-zA-Z0-9]/g, '')
  //         : event.target.value
  //   })
  // }

  // const handleOnDateChange = (newDate: Date) => {
  //   setSearchParams({
  //     ...searchParams,
  //     competencia: newDate
  //   })
  // }

  // const handleChangeEmpresa = (idEmpresa: number) => {
  //   const params = {
  //     ...searchParams,
  //     empresa: empresas.find((emp) => emp.idEmpresa === idEmpresa)
  //   }
  //   setSearchParams(params)
  // }

  // const handleChangeCentro = (idCentro: number) => {
  //   const params: ISearchParamsDocumento = {
  //     ...searchParams,
  //     centro: centros.find((centro) => centro.idCentro === idCentro)
  //   }
  //   setSearchParams(params)
  // }

  const handleViewContractModal = (contractId: number) => {
    setSelectedContractId(contractId)
  }

  const handleSearch = (form: ISearchParamsDocumento = {} as ISearchParamsDocumento) => {
    setLoading('loading')
    const formatData: IDocumentoCaixaSearchDto = {
      ...(form?.cnpj && {
        cnpj: unmask(form.cnpj) || '',
      }),
      ...(form?.idCentro && {
        codCentro: form.idCentro || 0,
      }),
      ...(form?.idEmpresa && {
        codEmpresa: form.idEmpresa || 0,
      }),
      ...(form?.competencia && {
        competencia: moment(form.competencia).format('YYYYMM')
      }),
      ...(form?.fornecedor && {
        fornecedor: form.fornecedor
      }),
      ...(form?.caixaDepartamental && {
        nuCaixaDepartamental: Number(form.caixaDepartamental) || 0,
      }),
      ...(form?.caixaExterno && {
        nuCaixaExterno: Number(form.caixaExterno) || 0,
      }),
      ...(form?.contrato && {
        numContrato: form.contrato || ''
      }),
    }

    DocumentoCaixaServices()
      .search(formatData, page, rowsPerPage)
      .then(({ data }) => {
        setDocumentosCaixa(data.items)
        setRowSize(data.pageCount)
        setLoading('idle')
      })
      .catch(() => {
        // setMsgErro('Não foi possivel obter dados da pesquisa.')
        showModal({
          hideButtonCancel: true,
          message: 'Erro ao obter os dados da pesquisa.',
          txtButtonConfirm: 'OK',
          type: 'alert'
        })
        setLoading('error')
      })
  }

  const handleSetDocumentoCaixas = () => {
    setLoading('loading')
    DocumentoCaixaServices()
      .getAllPaginated(1, rowsPerPage)
      .then(({ data }) => {
        setRowSize(data.pageCount)
        setDocumentosCaixa(data.items)
        setLoading('idle')
      })
      .catch(() => {
        // setMsgErro('Não foi possivel obter dados.')
        showModal({
          hideButtonCancel: true,
          message: 'Erro ao obter os dados da pesquisa.',
          txtButtonConfirm: 'OK',
          type: 'alert'
        })
        setLoading('error')
      })
  }

  // const handleClickSearch = () => {
  //   if (page === 1) {
  //     handleSearch()
  //   } else {
  //     setPage(1)
  //   }
  // }

  useEffect(() => {
    const formCache = watch()
    handleSearch(formCache)
  }, [page, rowsPerPage])

  useEffect(() => {
    setLoading('loading')
    CompanyServices()
      .getAll()
      .then(({ data }) => {
        const empresas: { nmEmpresa: string; idEmpresa: number }[] = []
        data
          .filter((contrato) => contrato.flAtiva)
          .map((contrato) => {
            empresas.push({
              idEmpresa: contrato.idEmpresa,
              nmEmpresa: contrato.txDescricao
            })
          })
        setEmpresas(empresas)
      })
      .catch(() => {
        // setMsgErro('Não foi possivel obter Contratos.')
        showModal({
          hideButtonCancel: true,
          message: 'Erro ao obter os dados da pesquisa.',
          txtButtonConfirm: 'OK',
          type: 'alert'
        })
      })

    CenterServices()
      .getAll()
      .then(({ data }) => {
        const centros: { nmCentro: string; idCentro: number }[] = []
        data.entity.map((centro) => {
          centros.push({
            idCentro: centro.idCentroPlanta,
            nmCentro: centro.txDescricao
          })
        })
        setCentros(centros)
      })
      .catch(() => {
        // setMsgErro('Não foi possivel obter os Centros Planta.')
        showModal({
          hideButtonCancel: true,
          message: 'Não foi possivel obter os Centros Planta.',
          txtButtonConfirm: 'OK',
          type: 'alert'
        })
      })
  }, [])

  return (
    <Card
      marginLeft={SPACING.spacing20}
      marginRight={SPACING.spacing20}
      marginBottom={SPACING.spacing100}
      padding={SPACING.spacing20}
      boxShadow={`0 0 1em ${COLORS.lightGray}`}
    >
      <FilterTableRegister
        control={control}
        errors={errors}
        handleSubmit={handleSubmit}
        // handleOnDateChange={handleOnDateChange}
        handleSearch={handleSearch}
        handleCleanFields={cleanFields}
        // handleChange={handleChangeFields}
        empresas={empresas}
        centros={centros}
      // handleChangeCentro={handleChangeCentro}
      // handleChangeEmpresa={handleChangeEmpresa}
      />
      <TableRegisterDocumentation
        selectedContractInfo={handleViewContractModal}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        setPage={setPage}
        rowsSize={rowSize}
        page={page}
        tableData={documentosCaixa}
        handleSetDocumentoCaixas={handleSetDocumentoCaixas}
        handleEdit={handleEdit}
      />
      <SuccessModal
        open={toggleDeleteModal}
        message="Confirma exclusão (S/N)?"
        type="alert"
        txtButtonCancel="NÃO"
        txtButtonConfirm="SIM"
        handleCancel={setToggleOpenDeleteModal}
        handleConfirm={() => handleDeleteDocumentoCaixa()}
      />
      <ViewContractModal
        showModal={openViewContractModal}
        toggleModal={toggleViewContractModal}
        contractID={selectedContractId}
      />
    </Card>
  )
}

export default SearchDocumentation
